import { render } from "./LinkField.vue?vue&type=template&id=2bd278e4"
import script from "./LinkField.vue?vue&type=script&lang=js"
export * from "./LinkField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__